import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import PropTypes from "prop-types";
import { TOKEN } from "../../data/constants";
const PrivateRoute = ({ children }) => {
  const { userId } = useUser();
  const location = useLocation();
  const token = localStorage.getItem(TOKEN.ACCESSTOKEN); 
  if (!token || token.trim() === "" || !userId || userId <= 0) {
    // Every unauthenticated bounce carries where it came from, so login can return there.
    // userId === 0 used to be sent to a bare /signin: that is what useLogout leaves behind
    // (localStorage.clear() then setUserId(0)), so anyone who had logged out in this session lost
    // the page they were trying to reach - including the emailed PostIF approval deep link, which
    // Epic 79824 AC1 requires to be returned to after login. A fresh browser (userId null) always
    // kept it, which is why this only ever failed for some people.
    return (
      <Navigate
        to={`/signin?redirect=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }
  if (userId <= 0) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }
  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
export default PrivateRoute;
